import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose } from 'redux';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

import { UserNoInfoPanel } from 'backoffice/_components';

import { MoneyCell, BaseTable, RowLink } from 'common/components';
import noInfoImage from 'common/images/noInfo.svg';
import { withTheme } from 'common/styling/theme';

import { getUserPammAccounts } from '../../_redux';

import { staticStyles, getDynamicStyles } from './style';

const UserPammAccounts = ({ userPammAccounts, getUserPammAccounts, userId, theme }) => {
  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;
  const history = useHistory();

  useEffect(() => {
    getUserPammAccounts({ userId });
  }, [getUserPammAccounts]);

  /* eslint-disable */
  const columns = [
    {
      key: 'rammInvestment',
      Cell: ({ original: { id, strategy } }) => (
        <RowLink link={`/backoffice/users/${userId}/investments_crm/${id}/open_trades`}>
          <div className="UserPammAccounts__title">
            <span className="title">{strategy.title}</span>
            <span className="masterAccount">
              <FormattedMessage id="investmentId">{txt => txt}</FormattedMessage>
              {` #${id}`}
            </span>
          </div>
        </RowLink>
      ),
    },
    {
      key: 'rammInvestmentEquity',
      Cell: ({ original: { id, equity } }) => (
        <RowLink link={`/backoffice/users/${userId}/investments_crm/${id}/open_trades`}>
          <MoneyCell inTable value={equity} />
        </RowLink>
      ),
    },

    {
      key: 'justBalance',
      Cell: ({ original: { id, balance } }) => (
        <RowLink link={`/backoffice/users/${userId}/investments_crm/${id}/open_trades`}>
          <MoneyCell inTable value={balance} />
        </RowLink>
      ),
    },
    {
      key: 'justManager',
      Cell: ({
        original: {
          strategy: { id, manager },
        },
      }) => (
        <div>
          {manager ? (
            <RowLink link={`/backoffice/users/${userId}/investments_crm/${id}/open_trades`}>
              <Link
                className="UserPammAccounts__manager-link"
                to={`/backoffice/users/${manager.id}`}
                onClick={e => e.stopPropagation()}>
                {manager.firstName} {manager.lastName}
              </Link>
            </RowLink>
          ) : (
            '-'
          )}
        </div>
      ),
    },
    {
      key: 'rammCurrentIncome',
      Cell: ({ original: { pnl, id } }) => (
        <RowLink link={`/backoffice/users/${userId}/investments_crm/${id}/open_trades`}>
          <MoneyCell inTable value={pnl} />
        </RowLink>
      ),
    },
  ];
  /* eslint-enable */

  const rowProps = (state, rowInfo) => ({
    onClick: () => history.push(`/backoffice/users/${userId}/investments_crm/${rowInfo.original.id}/open_trades`),
  });

  return (
    <div
      className={classNames('UserPammAccounts', {
        'UserPammAccounts--noAccounts': !userPammAccounts.length,
      })}>
      <div className="UserPammAccounts__head">
        <FormattedMessage id="boPammInvestorAccounts">{txt => <h2>{txt}</h2>}</FormattedMessage>
      </div>
      {userPammAccounts.length > 0 ? (
        <div className="UserPammAccounts__body">
          <BaseTable columns={columns} data={userPammAccounts} getTrProps={rowProps} />
        </div>
      ) : (
        <UserNoInfoPanel image={noInfoImage} textId="boNoInvestNewAccounts" />
      )}

      <style jsx global>
        {staticStyles}
      </style>
      <style jsx>{dynamicStyles}</style>
    </div>
  );
};

UserPammAccounts.propTypes = {
  getUserPammAccounts: PropTypes.func.isRequired,
  userPammAccounts: PropTypes.array.isRequired,
  userId: PropTypes.string,
  theme: PropTypes.object,
};

UserPammAccounts.defaultProps = {
  userId: '',
  theme: {},
};

export default compose(
  withTheme(),
  connect(
    state => ({
      userPammAccounts: state.backoffice.users.userPammAccounts,
    }),
    { getUserPammAccounts: data => getUserPammAccounts.request(data) }
  )
)(UserPammAccounts);
export { UserPammAccounts };
